module.exports = __webpack_public_path__ + "static/img/services-page-top-image.bc54f33e.png";